const MAIN_IMAGE_CLASS = 'js-product-main-image';
const THUMB_CLASS = 'js-product-thumb';
const VISIBLE_MODIFIER = 'is-active';

let lightGalleryPromise = null;

function loadLightGallery() {
	if (!lightGalleryPromise) {
		lightGalleryPromise = Promise.all([
			import('../../lib/lightgallery/lightgallery.es5.js'),
			import('../../lib/lightgallery/plugins/thumbnail/lg-thumbnail.es5.js'),
			import('../../lib/lightgallery/css/lightgallery.css'),
			import('../../lib/lightgallery/css/lg-thumbnail.css'),
		]).then(([lightGalleryModule, thumbnailModule]) => ({
			lightGallery: lightGalleryModule.default,
			lgThumbnail: thumbnailModule.default,
		}));
	}
	return lightGalleryPromise;
}

function buildGalleryItems(root) {
	return Array.from(root.querySelectorAll(`.${THUMB_CLASS}`)).map((thumb) => {
		const image = thumb.querySelector('img');
		return {
			src: image ? image.src : '',
			thumb: image ? image.src : '',
			alt: image ? image.alt : '',
		};
	});
}

function activeThumbIndex(root) {
	const thumbs = Array.from(root.querySelectorAll(`.${THUMB_CLASS}`));
	const active = root.querySelector(`.${THUMB_CLASS}.${VISIBLE_MODIFIER}`);
	const index = thumbs.indexOf(active);
	return index === -1 ? 0 : index;
}

// lightGallery's own `loop: false` only stops navigation at the ends — it keeps
// showing prev/next there. This site's convention (matched from the popup this
// replaces) is to not offer the control at all past either end.
function updateEdgeControls(index, total) {
	const prevBtn = document.querySelector('.lg-prev');
	const nextBtn = document.querySelector('.lg-next');
	if (prevBtn) {
		prevBtn.style.display = index <= 0 ? 'none' : '';
	}
	if (nextBtn) {
		nextBtn.style.display = index >= total - 1 ? 'none' : '';
	}
}

function init() {
	const root = document.querySelector('.c-product-detail');
	if (!root) {
		return;
	}

	document.body.addEventListener('click', (event) => {
		const mainImage = event.target.closest(`.${MAIN_IMAGE_CLASS}`);
		if (!mainImage) {
			return;
		}

		const galleryRoot = mainImage.closest('.c-product-detail');
		if (!galleryRoot) {
			return;
		}

		loadLightGallery().then(({ lightGallery, lgThumbnail }) => {
			const dynamicEl = buildGalleryItems(galleryRoot);
			if (!dynamicEl.length) {
				return;
			}

			const index = activeThumbIndex(galleryRoot);
			const total = dynamicEl.length;
			const instance = lightGallery(galleryRoot, {
				dynamic: true,
				dynamicEl,
				index,
				loop: false,
				download: false,
				plugins: [lgThumbnail],
			});

			galleryRoot.addEventListener('lgAfterOpen', () => {
				updateEdgeControls(index, total);
			}, { once: true });

			galleryRoot.addEventListener('lgAfterSlide', (event) => {
				updateEdgeControls(event.detail.index, total);
			});

			galleryRoot.addEventListener('lgAfterClose', () => {
				instance.destroy();
				document.documentElement.classList.remove('no-scroll');
			}, { once: true });

			document.documentElement.classList.add('no-scroll');
			instance.openGallery(index);
		});
	});
}

document.addEventListener('DOMContentLoaded', init);
